'use client';

import type { ReactNode } from 'react';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card';
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';
import { cn } from '@/lib/utils/style';

interface HoverCardTooltipProps {
  children: ReactNode;
  text: string;
  sideOffset?: number;
  openDelay?: number;
  closeDelay?: number;
  contentClassName?: string;
  portalled?: boolean;
}

// HoverCard 的统一样式
const hoverCardContentStyle = {
  width: 'fit-content',
  borderRadius: '99999px',
  border: '1px solid rgba(0, 0, 0, 0.05)',
  background: 'rgba(255, 255, 255, 0.90)',
  boxShadow: '0 4px 20px 0 rgba(98, 79, 22, 0.05)',
  backdropFilter: 'blur(120px)',
};

// 文本样式
const textStyle = {
  fontFamily: 'var(--font-sans)',
  lineHeight: '140%',
};

export function HoverCardTooltip({ children, text, sideOffset = 18, openDelay = 120, closeDelay = 80, contentClassName, portalled = false }: HoverCardTooltipProps) {
  const content = text ? (
    <HoverCardContent side="right" align="center" sideOffset={sideOffset} className={cn('px-[12px] py-[4px]', contentClassName)} style={hoverCardContentStyle}>
      <p className="text-[#2A2A29] text-[14px]" style={textStyle}>
        {text}
      </p>
    </HoverCardContent>
  ) : null;
  return (
    <HoverCard openDelay={openDelay} closeDelay={closeDelay}>
      <HoverCardTrigger asChild>{children}</HoverCardTrigger>
      {portalled ? <HoverCardPrimitive.Portal>{content}</HoverCardPrimitive.Portal> : content}
    </HoverCard>
  );
}
